<ion-item class="input-date-time" *transloco="let t">
  <ion-label *ngIf="label" position="stacked">{{ label }}</ion-label>
  <ion-datetime
    [ngClass]="{
      error: (control && control.invalid && control.touched) || false
    }"
    presentation="time"
    [(ngModel)]="internalValue"
    (blur)="onTouched($event)"
    [max]="maxDate"
    [cancelText]="t('common.cancel')"
    [doneText]="t('common.accept')"
  ></ion-datetime>
  <span
    *ngIf="(control && control.invalid && control.touched) || false"
    class="error"
    >{{ error ? error : t('common.required') }}</span
  >
  <span
    *ngIf="!(control && control.invalid && control.touched)"
    [ngStyle]="{
      visibility:
        !(control && control.invalid && control.touched) && caption
          ? 'visible'
          : 'hidden'
    }"
    >{{ caption }}</span
  >
</ion-item>
